// src/components/SingleQuestionInfoCard.jsx
import React from "react";
// Import the new reusable component
import FormattedText from "../../Utility/FormattedText"; // Adjust path as needed

const SingleQuestionInfoCard = ({
  question,
  verdict,
  userAnswerText,
  localUrl,
  status, // 'not_started' | 'started' | 'success' | 'failed' | null
  onRetry
}) => {

  // --- RENDER HELPERS BASED ON STATUS ---
  const renderStatusSection = () => {
    // Case 1: Processing (Started)
    if (status === 'started') {
      return (
        <div className="bg-blue-50 border border-blue-200 rounded-md p-4 flex items-center gap-3">
          <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-blue-600"></div>
          <span className="text-blue-700 font-medium">Processing your answer...</span>
        </div>
      );
    }

    // Case 2: Failed / Not Started / Null
    if ( status === 'failed' || status === 'not_started') {
      return (
        <div className="bg-red-50 border border-red-200 rounded-md p-4 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3">
          <span className="text-red-700 font-medium">Failed to process your answer.</span>
          {true && (
            <button
              onClick={onRetry}
              className="px-4 py-1.5 bg-red-600 text-white text-sm rounded hover:bg-red-700 transition-colors"
            >
              Retry
            </button>
          )}
        </div>
      );
    }

    // Case 3: Success -> Show Verdict
    if (status === 'success') {
      return (
        <div className="mb-4">
          <div className="font-bold text-lg">
            Verdict:{" "}
            {verdict === null ? (
              <span className="text-gray-600">Checking...</span>
            ) : verdict ? (
              <span className="text-green-600">Correct</span>
            ) : (
              <span className="text-red-600">Wrong</span>
            )}
          </div>
        </div>
      );
    }

    return null;
  };

  return (
    <div className="w-full max-w-4xl mx-auto">
      <div className="border border-gray-300 p-6 rounded-lg bg-white shadow-sm">

        {/* --- QUESTION SECTION --- */}
        <div className="mb-4 text-lg font-medium text-gray-900">
          <FormattedText text={question.text} />
        </div>

        {/* Optional Image */}
        {question.imageSrc && question.imageSrc.trim() !== "" && (
          <div className="mb-6">
            <img
              src={question.imageSrc}
              alt="Question reference"
              className="max-w-xs h-auto rounded-md border border-gray-200"
            />
          </div>
        )}

        {/* ID */}
        <div className="text-xs text-gray-400 mb-6 font-mono">ID: {question.id}</div>

        {/* --- STATUS / VERDICT SECTION --- */}
        {renderStatusSection()}

        {/* --- ANSWER SECTION (Only show if success) --- */}
        {true && (
          <div className="mt-4 border-t border-gray-100 pt-4">
            <div className="mb-2 text-sm uppercase tracking-wide text-gray-500 font-semibold">
              Your Answer
            </div>

            <div className="mb-6 text-gray-800 bg-gray-50 p-3 rounded border border-gray-100">
              <FormattedText text={userAnswerText || "No text recognized."} />
            </div>

            {/* Audio Player */}
            <div className="flex flex-col sm:flex-row sm:items-center gap-3">
              {localUrl ? (
                <audio
                  controls
                  src={localUrl}
                  className="h-10 w-full sm:w-[380px]"
                />
              ) : (
                <div className="h-10 w-full sm:w-[380px] rounded-full bg-gray-100 border border-gray-200 flex items-center px-4">
                  <div className="w-3 h-3 rounded-full bg-gray-300 mr-3" />
                  <div className="text-gray-400 text-sm italic">Audio unavailable</div>
                </div>
              )}
            </div>
          </div>
        )}

      </div>
    </div>
  );
};

export default SingleQuestionInfoCard;